import { Share2, Camera, UserPlus, Clock, ShieldCheck, Megaphone, Flag, MessageCircle, Users, Star, Eye, CalendarDays, Heart, Gift, Crown, Store, Coins } from "lucide-react";

export const VipBadge = () => null;

export const fmtK = (v) => String(Math.round((Number(v) || 0) * 100) / 100);

export const POINT_ICONS = { share: Share2, camera: Camera, "user-plus": UserPlus, clock: Clock, shield: ShieldCheck, megaphone: Megaphone, flag: Flag,
  message: MessageCircle, users: Users, star: Star, eye: Eye, calendar: CalendarDays, heart: Heart, gift: Gift, crown: Crown, store: Store, coins: Coins };

export const PointIcon = ({ name, className }) => {
  const I = POINT_ICONS[name] || Star;
  return <I className={className} />;
};

export const Coin = ({ size = 40 }) => (
  <img src="/gjejkredit.png" alt="GjejKredit" className="shrink-0 rounded-full object-contain" style={{ width: size, height: size }} />
);

const MONTHS = ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Korr", "Gush", "Sht", "Tet", "Nën", "Dhj"];
export const fmtDate = (iso) => { const d = new Date(iso); return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`; };
